import React from "react";

export interface Props {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  onClick?: () => void;
}

export const RightIcon = ({
  width = 24,
  height = 24,
  color = "#7D7D7D",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftIcon = ({
  width = 24,
  height = 24,
  color = "#7D7D7D",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 18L9 12L15 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({
  width = 24,
  height = 24,
  color = "#7D7D7D",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.71 19.29L17.31 15.9C18.407 14.5025 19.0022 12.7767 19 11C19 9.41775 18.5308 7.87103 17.6518 6.55544C16.7727 5.23985 15.5233 4.21447 14.0615 3.60897C12.5997 3.00347 10.9911 2.84504 9.43928 3.15372C7.88743 3.4624 6.46197 4.22433 5.34315 5.34315C4.22433 6.46197 3.4624 7.88743 3.15372 9.43928C2.84504 10.9911 3.00347 12.5997 3.60897 14.0615C4.21447 15.5233 5.23985 16.7727 6.55544 17.6518C7.87103 18.5308 9.41775 19 11 19C12.7767 19.0022 14.5025 18.407 15.9 17.31L19.29 20.71C19.383 20.8037 19.4936 20.8781 19.6154 20.9289C19.7373 20.9797 19.868 21.0058 20 21.0058C20.132 21.0058 20.2627 20.9797 20.3846 20.9289C20.5064 20.8781 20.617 20.8037 20.71 20.71C20.8037 20.617 20.8781 20.5064 20.9289 20.3846C20.9797 20.2627 21.0058 20.132 21.0058 20C21.0058 19.868 20.9797 19.7373 20.9289 19.6154C20.8781 19.4936 20.8037 19.383 20.71 19.29V19.29ZM5 11C5 9.81332 5.3519 8.65328 6.01119 7.66658C6.67047 6.67989 7.60755 5.91085 8.7039 5.45673C9.80026 5.0026 11.0067 4.88378 12.1705 5.11529C13.3344 5.3468 14.4035 5.91825 15.2426 6.75736C16.0818 7.59648 16.6532 8.66558 16.8847 9.82946C17.1162 10.9933 16.9974 12.1997 16.5433 13.2961C16.0892 14.3925 15.3201 15.3295 14.3334 15.9888C13.3467 16.6481 12.1867 17 11 17C9.4087 17 7.88258 16.3679 6.75736 15.2426C5.63214 14.1174 5 12.5913 5 11Z"
        fill={color}
      />
    </svg>
  );
};

export const CloseIcon = ({
  width = 18,
  height = 18,
  color = "#F8FAFC",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 4.5L4.5 13.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 4.5L13.5 13.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EducationalIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7713)">
        <path
          d="M11.2838 13.865C10.9278 14.0833 10.472 14.2036 10.0001 14.2036C9.52833 14.2036 9.07245 14.0834 8.71649 13.865L2.90492 10.3008C2.90492 10.3008 2.38037 9.97923 2.38037 10.7076C2.38037 11.5347 2.38037 14.0161 2.38037 14.0161C2.38037 14.0492 2.38037 14.2153 2.38037 14.2668C2.38037 16.1417 5.79181 18.1629 9.99999 18.1629C14.2082 18.1629 17.6196 16.1417 17.6196 14.2668C17.6196 14.2153 17.6196 14.0492 17.6196 14.0161C17.6196 14.0161 17.6196 11.3843 17.6196 10.5069C17.6196 9.92229 17.2467 10.208 17.2467 10.208L11.2838 13.865Z"
          fill={color}
        />
        <path
          d="M19.6651 7.4656C20.1116 7.19174 20.1116 6.74359 19.6651 6.46968L10.8119 2.04253C10.3653 1.76868 9.63461 1.76868 9.18806 2.04253L0.334912 6.46968C-0.111637 6.74354 -0.111637 7.19169 0.334912 7.4656L9.18806 12.8953C9.63461 13.1692 10.3653 13.1692 10.8119 12.8953"
          fill={color}
        />
        <path
          d="M19.2987 15.5137C19.2987 14.0146 19.2987 9.51704 19.2987 9.51704C19.2987 9.51704 19.3029 9.233 19.1344 9.3268C18.9992 9.40204 18.6678 9.58677 18.551 9.68833C18.4162 9.80548 18.4466 10.0685 18.4466 10.0685C18.4466 10.0685 18.4466 14.1524 18.4466 15.5137C18.4466 15.591 18.3802 15.6279 18.3485 15.6466C18.0424 15.8265 17.8367 16.1586 17.8367 16.5393C17.8367 17.1115 18.3005 17.5753 18.8727 17.5753C19.4449 17.5753 19.9087 17.1115 19.9087 16.5393C19.9087 16.1571 19.7014 15.824 19.3934 15.6445C19.3627 15.6267 19.2987 15.591 19.2987 15.5137Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7713">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdventureIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7722)">
        <path
          d="M10 3.53516C11.2712 3.53516 12.4802 3.80598 13.573 4.29227C14.1923 3.8684 14.5996 3.15648 14.5996 2.35105C14.5996 1.05469 13.5449 0 12.2485 0H7.75148C6.45508 0 5.40039 1.05469 5.40039 2.35109C5.40039 3.15652 5.80766 3.86844 6.42691 4.2923C7.51977 3.80602 8.72875 3.53516 10 3.53516V3.53516ZM6.57227 2.35109C6.57227 1.70086 7.10125 1.17188 7.75148 1.17188H12.2485C12.8987 1.17188 13.4277 1.70086 13.4277 2.35109C13.4277 3.00133 12.8987 3.53031 12.2485 3.53031H11.7627V2.93945C11.7627 2.61586 11.5004 2.35352 11.1768 2.35352H8.82324C8.49965 2.35352 8.2373 2.61586 8.2373 2.93945V3.53027H7.75148C7.10125 3.53027 6.57227 3.00129 6.57227 2.35109Z"
          fill={color}
        />
        <path
          d="M11.2329 12.7577L12.2907 10.0629L9.59595 11.1208L11.2329 12.7577Z"
          fill={color}
        />
        <path
          d="M10 4.70703C5.78371 4.70703 2.35352 8.13723 2.35352 12.3535C2.35352 16.5698 5.78371 20 10 20C14.2163 20 17.6465 16.5698 17.6465 12.3535C17.6465 8.13723 14.2163 4.70703 10 4.70703ZM13.8724 9.2407L11.9966 14.0188C11.9371 14.1705 11.817 14.2906 11.6653 14.3501L6.88719 16.2259C6.8177 16.2532 6.74512 16.2664 6.67316 16.2664C6.52055 16.2664 6.3707 16.2068 6.25875 16.0948C6.09398 15.93 6.0425 15.6832 6.12766 15.4663L8.00344 10.6882C8.06297 10.5365 8.18305 10.4164 8.33473 10.3569L13.1129 8.48113C13.3298 8.39594 13.5765 8.4475 13.7413 8.61223C13.9061 8.77699 13.9575 9.02379 13.8724 9.2407V9.2407Z"
          fill={color}
        />
        <path
          d="M8.76741 11.9493L7.70947 14.6441L10.4043 13.5863L8.76741 11.9493Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7722">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ActionIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7739)">
        <path
          d="M19.4139 0H17.6388C17.4833 0 17.3343 0.0617188 17.2245 0.171641L5.86133 11.5347L8.46516 14.1386L19.8282 2.77543C19.9382 2.66555 19.9999 2.51652 19.9999 2.36109V0.585937C19.9999 0.262344 19.7375 0 19.4139 0V0Z"
          fill={color}
        />
        <path
          d="M2.33535 15.0661C1.98762 15.4139 1.80266 15.8684 1.78531 16.3268C1.3325 16.3394 0.883476 16.518 0.537852 16.8636C-0.179609 17.5811 -0.179609 18.7444 0.537852 19.4619C1.25531 20.1793 2.41859 20.1793 3.13609 19.4619C3.47961 19.1184 3.6582 18.6726 3.67277 18.2226C4.12289 18.208 4.56867 18.0293 4.91223 17.6857L5.97629 16.6216L3.37805 14.0234L2.33535 15.0661Z"
          fill={color}
        />
        <path
          d="M10.8262 13.4323L13.4296 10.8288L14.1356 11.5348L11.5322 14.1383L10.8262 13.4323Z"
          fill={color}
        />
        <path
          d="M6.56754 9.17133L9.17137 6.5675L2.77547 0.171641C2.66559 0.0617188 2.51656 0 2.36113 0H0.585938C0.262344 0 0 0.262344 0 0.585938V2.36109C0 2.51652 0.0617188 2.66555 0.171641 2.77539L6.56754 9.17133Z"
          fill={color}
        />
        <path
          d="M18.2145 16.3268C18.1971 15.8684 18.0121 15.4139 17.6644 15.0662L16.6217 14.0234L14.0234 16.6216L15.0875 17.6857C15.4311 18.0293 15.8769 18.208 16.327 18.2226C16.3416 18.6726 16.5202 19.1184 16.8637 19.4619C17.5811 20.1793 18.7444 20.1793 19.4619 19.4619C20.1794 18.7444 20.1794 17.5811 19.4619 16.8636C19.1163 16.5181 18.6673 16.3394 18.2145 16.3268V16.3268Z"
          fill={color}
        />
        <path
          d="M17.3185 10.841C17.0896 10.6121 16.7186 10.6122 16.4898 10.841L10.8411 16.4897C10.6122 16.7185 10.6122 17.0895 10.8411 17.3183C11.0698 17.5471 11.4409 17.5471 11.6697 17.3183L17.3185 11.6696C17.5473 11.4408 17.5473 11.0698 17.3185 10.841V10.841Z"
          fill={color}
        />
        <path
          d="M3.51026 10.841C3.28147 10.6122 2.91046 10.6121 2.68163 10.841C2.4528 11.0698 2.4528 11.4408 2.68163 11.6696L8.33042 17.3183C8.55921 17.5471 8.93026 17.5471 9.15905 17.3183C9.38788 17.0895 9.38788 16.7185 9.15905 16.4897L3.51026 10.841Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7739">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PuzzleIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7707)">
        <path
          d="M17.6191 9.52379H16.1905V5.71429C16.1905 4.66192 15.3381 3.80951 14.2857 3.80951H10.4762V2.38094C10.4762 1.06665 9.40951 0 8.09522 0C6.78094 0 5.71429 1.06665 5.71429 2.38094V3.80951H1.90478C0.852411 3.80951 0.00955357 4.66188 0.00955357 5.71429L0.00477679 9.33335H1.42857C2.84763 9.33335 4 10.4857 4 11.9048C4 13.3238 2.84763 14.4762 1.42857 14.4762H0.00477679L0 18.0952C0 19.1476 0.852366 20 1.90478 20H5.52384V18.5714C5.52384 17.1524 6.67621 16 8.09527 16C9.51433 16 10.6667 17.1524 10.6667 18.5714V20H14.2857C15.3381 20 16.1905 19.1476 16.1905 18.0952V14.2857H17.6191C18.9333 14.2857 20 13.2191 20 11.9048C20 10.5905 18.9333 9.52379 17.6191 9.52379Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7707">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AllIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM14.1667 17.5C16.005 17.5 17.5 16.005 17.5 14.1667C17.5 12.3283 16.005 10.8333 14.1667 10.8333C12.3283 10.8333 10.8333 12.3283 10.8333 14.1667C10.8333 16.005 12.3283 17.5 14.1667 17.5Z"
        fill={color}
      />
    </svg>
  );
};

export const SportIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7693)">
        <path
          d="M10.8146 1.61554C11.0408 1.31573 11.0044 0.679815 10.9722 0.118853C10.971 0.0946733 10.9696 0.0710254 10.9683 0.0470093C10.6512 0.0167335 10.3302 0 10.0054 0C8.76058 0 7.56951 0.229319 6.47021 0.645039C7.2544 1.02189 8.46826 1.67053 9.8175 2.62892C10.2779 2.23276 10.625 1.86704 10.8146 1.61554Z"
          fill={color}
        />
        <path
          d="M15.8815 7.32166C15.3886 7.37734 14.9729 7.45823 14.6174 7.57168C16.3168 10.5388 16.9794 14.2874 17.1416 17.0031C18.8252 15.2877 19.8943 12.9687 19.9954 10.4C18.8354 8.97406 17.2986 7.16091 15.8815 7.32166Z"
          fill={color}
        />
        <path
          d="M5.77823 4.76052C6.97229 4.51206 8.09409 3.91108 8.98853 3.27672C7.12256 1.99155 5.56622 1.32459 5.25663 1.19763C3.32074 2.24415 1.7716 3.91157 0.870361 5.93191C2.04179 5.46517 3.31047 5.22771 4.55656 4.99635C4.95968 4.92148 5.37638 4.84411 5.77823 4.76052Z"
          fill={color}
        />
        <path
          d="M12.6902 5.05125C12.7968 5.15837 12.9031 5.26732 13.0086 5.37832C13.3981 5.78724 13.7516 6.23451 14.0757 6.70771C14.5477 6.52949 15.1034 6.40311 15.7686 6.32791C17.3358 6.15064 18.7294 7.39215 19.9255 8.75898C19.6691 6.68693 18.7804 4.81158 17.4563 3.33261C16.7335 3.41972 15.9277 3.56729 15.1064 3.81236C14.5677 3.97327 13.7097 4.41047 12.6902 5.05125Z"
          fill={color}
        />
        <path
          d="M11.3744 10.2156C11.7846 8.82637 12.2596 7.82494 13.1801 7.17491C12.9039 6.77833 12.6066 6.40615 12.2846 6.06804C12.1356 5.91159 11.9849 5.76049 11.8336 5.61206C8.1407 8.12573 3.08206 12.7432 2.62207 16.744C4.15754 18.424 6.25893 19.5761 8.62454 19.9029C9.48588 18.1881 10.2966 14.7019 10.7785 12.6285C11.01 11.6327 11.2098 10.7728 11.3744 10.2156Z"
          fill={color}
        />
        <path
          d="M7.18725 8.01259C8.47487 6.82606 9.83466 5.76207 11.0784 4.90694C10.6638 4.54016 10.248 4.20205 9.83973 3.89197C8.80672 4.6685 7.45421 5.43333 5.98198 5.73953C5.5697 5.82532 5.14752 5.90375 4.73936 5.97953C3.16674 6.27157 1.65712 6.5544 0.387584 7.26273C0.140345 8.133 0.00512695 9.05052 0.00512695 10C0.00512695 12.1241 0.669477 14.0922 1.79872 15.7117C2.53029 12.8151 5.03959 9.9916 7.18725 8.01259Z"
          fill={color}
        />
        <path
          d="M11.9398 4.3358C13.1294 3.57734 14.1551 3.05292 14.8206 2.85428C15.4181 2.67582 16.0043 2.54584 16.5595 2.45104C15.2767 1.33636 13.7087 0.541908 11.9777 0.195618C12.0161 0.894007 12.0328 1.66076 11.6127 2.21784C11.4131 2.48238 11.0754 2.8452 10.636 3.23883C11.0663 3.57379 11.5036 3.93906 11.9398 4.3358Z"
          fill={color}
        />
        <path
          d="M12.3331 10.4987C12.177 11.0276 11.9801 11.8744 11.7522 12.8548C11.0794 15.7496 10.4357 18.3399 9.68384 19.9918C9.79058 19.9952 9.89728 20 10.0048 20C12.3354 20 14.4778 19.2006 16.178 17.864C16.1109 15.0222 15.4296 11.0025 13.7135 8.01855C13.0479 8.51324 12.6897 9.29145 12.3331 10.4987Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7693">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RacingIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7730)">
        <path
          d="M16.8538 2.66406C15.6926 2.46406 14.4964 2.62679 13.3354 2.7413C12.1786 2.85541 10.9709 2.99507 9.82481 2.72379C8.47538 2.40438 7.62171 1.51983 6.9922 0.321342C6.81863 0.790945 6.6451 1.2605 6.47157 1.73015C5.33616 4.80228 4.20079 7.87441 3.06543 10.9465L0 19.2412L1.18384 19.6788L3.94257 12.2141C4.45456 12.7603 5.08667 13.1569 5.89813 13.349C7.04408 13.6201 8.252 13.4807 9.40863 13.3665C10.5695 13.2518 11.7659 13.0892 12.9271 13.2893C14.4192 13.5463 15.3833 14.4399 16.0732 15.7538C17.3823 12.2121 18.6911 8.67035 20 5.12857C19.3099 3.81469 18.3461 2.92114 16.8538 2.66406ZM16.9993 8.9699C16.4156 8.47723 15.7889 8.14777 15.0333 8.00251C14.7812 8.68437 14.5292 9.36624 14.2772 10.0481C15.0329 10.1934 15.6594 10.5229 16.2433 11.0155C16.0122 11.6408 15.7811 12.2662 15.55 12.8914C14.9663 12.3988 14.3395 12.0691 13.5839 11.924C13.815 11.2987 14.0461 10.6734 14.2772 10.0481C13.5078 9.92402 12.7566 9.92472 11.9803 9.97223C11.7492 10.5975 11.518 11.2229 11.287 11.8482C10.4837 11.9131 9.68322 12.0052 8.88001 12.07C9.11106 11.4446 9.3422 10.8193 9.57325 10.1941C8.79695 10.2417 8.04565 10.2424 7.27628 10.1183C7.04518 10.7436 6.81408 11.3689 6.58299 11.9941C5.82746 11.849 5.20052 11.5194 4.61689 11.0266C4.84794 10.4014 5.07908 9.77607 5.31013 9.15084C5.89398 9.64356 6.52062 9.97307 7.27628 10.1183C7.52824 9.43642 7.78033 8.75446 8.03229 8.0726C7.27667 7.9277 6.64995 7.59771 6.06614 7.10525C6.31819 6.4233 6.5702 5.74135 6.8222 5.05949C7.40605 5.55234 8.03269 5.88149 8.7883 6.02697C9.0194 5.40166 9.25049 4.77639 9.48159 4.15116C10.251 4.27525 11.0023 4.27454 11.7786 4.2269C11.5475 4.85217 11.3164 5.47748 11.0853 6.10275C11.8885 6.03787 12.689 5.94581 13.4923 5.88096C13.7233 5.25569 13.9545 4.63038 14.1856 4.00507C14.9619 3.95752 15.7131 3.95677 16.4825 4.0809C16.2514 4.70621 16.0203 5.33148 15.7892 5.95683C16.5449 6.10213 17.1714 6.43151 17.7553 6.92418C17.5034 7.60609 17.2515 8.28804 16.9993 8.9699Z"
          fill={color}
        />
        <path
          d="M10.3293 8.14839C10.0773 8.8303 9.82529 9.51216 9.57324 10.1941C10.3765 10.1291 11.1771 10.037 11.9803 9.97219C12.2323 9.29037 12.4843 8.60847 12.7363 7.92661C11.933 7.99149 11.1325 8.08359 10.3293 8.14839Z"
          fill={color}
        />
        <path
          d="M10.3295 8.1485C10.5815 7.46664 10.8335 6.78469 11.0855 6.10287C10.309 6.15029 9.55804 6.15108 8.78848 6.02708C8.53648 6.70895 8.28447 7.39085 8.03247 8.07272C8.80189 8.19693 9.5531 8.19618 10.3295 8.1485Z"
          fill={color}
        />
        <path
          d="M13.4923 5.88099C13.2403 6.56285 12.9883 7.24472 12.7363 7.92662C13.5127 7.87921 14.2638 7.87841 15.0333 8.00249C15.2853 7.32063 15.5373 6.63872 15.7893 5.95686C15.0199 5.83273 14.2687 5.83335 13.4923 5.88099Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7730">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlayIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      fill="#000000"
      height={height}
      width={width}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 60 60"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30 c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15 C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"
          fill={color}
        />
        <path
          d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30 S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const InfoIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      fill="#ffffff"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 416.979 416.979"
      xmlSpace="preserve"
      stroke="#ffffff"
    >
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g>
        {" "}
        <g>
          {" "}
          <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z" />{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const StrategyIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      fill="#000000"
      width={width}
      height={height}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 295.238 295.238"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M184.786,82.767c3.433-2.61,5.69-6.7,5.69-11.338c0-6.486-4.371-11.914-10.305-13.652
                        c3.495-5.752,5.543-12.471,5.543-19.681C185.714,17.09,168.624,0,147.619,0s-38.095,17.09-38.095,38.095
                        c0,7.21,2.048,13.929,5.543,19.681c-5.933,1.738-10.305,7.167-10.305,13.652c0,4.638,2.257,8.729,5.69,11.338
                        C67.3,98.21,38.095,138.843,38.095,185.714c0,60.395,49.129,109.524,109.524,109.524s109.524-49.129,109.524-109.524
                        C257.143,138.843,227.938,98.21,184.786,82.767z M147.619,9.524c15.757,0,28.571,12.814,28.571,28.571
                        c0,15.757-12.814,28.571-28.571,28.571s-28.571-12.814-28.571-28.571C119.048,22.338,131.862,9.524,147.619,9.524z
                        M119.048,66.667h3.457c6.714,5.91,15.49,9.524,25.114,9.524s18.4-3.614,25.114-9.524h3.457c2.629,0,4.762,2.138,4.762,4.762
                        c0,2.624-2.133,4.762-4.762,4.762h-9.524v33.333c0,25.348,12.105,49.552,32.381,64.762c2.271,1.7,3.957,4.048,4.89,6.667H200
                        H95.238H91.3c0.933-2.624,2.624-4.967,4.886-6.667c20.281-15.21,32.386-39.414,32.386-64.762V76.19h-9.524
                        c-2.629,0-4.762-2.138-4.762-4.762C114.286,68.805,116.419,66.667,119.048,66.667z M95.481,190.476
                        c2.414,26.657,24.862,47.619,52.138,47.619s49.724-20.962,52.138-47.619h14.529v-4.762c0-7.448-3.557-14.576-9.524-19.048
                        c-14.848-11.133-24.619-27.767-27.552-45.876c25.29,11.495,41.838,36.69,41.838,64.924c0,39.386-32.043,71.429-71.429,71.429
                        S76.19,225.1,76.19,185.714c0-28.233,16.548-53.429,41.838-64.924c-2.933,18.11-12.705,34.743-27.557,45.876
                        c-5.962,4.471-9.519,11.6-9.519,19.048v4.762H95.481z M105.029,190.476h85.186c-2.376,21.4-20.567,38.095-42.59,38.095
                        S107.405,211.876,105.029,190.476z M147.619,285.714c-55.138,0-100-44.862-100-100c0-44.714,29.1-83.219,71.429-95.752v19.562
                        c0,0.19-0.033,0.376-0.033,0.571c-31.429,11.871-52.348,41.819-52.348,75.619c0,44.638,36.314,80.952,80.952,80.952
                        s80.952-36.314,80.952-80.952c0-33.8-20.919-63.748-52.348-75.619c0-0.195-0.033-0.381-0.033-0.571V89.962
                        c42.329,12.533,71.429,51.038,71.429,95.752C247.619,240.852,202.757,285.714,147.619,285.714z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export const CardIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      version="1.1"
      id="_x32_"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          className="st0"
          d="M448.18,159.195l-0.091-0.811l-0.759,0.318c-5.822,5.134-26.168,14.278-32.269,15.226l-0.383,0.201
                    l0.019,0.428c2.226,5.763,4.478,27.953,2.947,35.56l0.104,0.818l0.746-0.325c5.822-5.133,26.162-14.278,32.275-15.226l0.377-0.201
                    l-0.013-0.428C448.894,188.991,446.643,166.802,448.18,159.195z"
          fill={color}
        />
        <rect
          x="36.552"
          y="352.646"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="132.917"
          y="352.646"
          width="48.183"
          height="48.182"
          fill={color}
        />
        <rect
          x="229.282"
          y="352.646"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="36.552"
          y="256.281"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="132.917"
          y="256.281"
          width="48.183"
          height="48.182"
          fill={color}
        />
        <rect
          x="229.282"
          y="256.281"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="84.735"
          y="304.463"
          width="48.182"
          height="48.183"
          fill={color}
        />
        <rect
          x="181.1"
          y="304.463"
          width="48.182"
          height="48.183"
          fill={color}
        />
        <rect
          x="36.552"
          y="159.916"
          width="48.182"
          height="48.183"
          fill={color}
        />
        <rect
          x="132.917"
          y="159.916"
          width="48.183"
          height="48.183"
          fill={color}
        />
        <rect
          x="229.282"
          y="159.916"
          width="48.182"
          height="48.183"
          fill={color}
        />
        <rect
          x="84.735"
          y="208.098"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="181.1"
          y="208.098"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="36.552"
          y="63.551"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="132.917"
          y="63.551"
          width="48.183"
          height="48.182"
          fill={color}
        />
        <rect
          x="229.282"
          y="63.551"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="84.735"
          y="111.733"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <rect
          x="181.1"
          y="111.733"
          width="48.182"
          height="48.182"
          fill={color}
        />
        <path
          d="M493.456,136.72L283.78,18.094c-15.816-8.905-35.488-4.855-46.391,8.904H36.552
                    C16.355,27.005,0,43.36,0,63.551v337.278c0,20.191,16.355,36.546,36.552,36.552h154.983l99.818,56.49
                    c17.614,9.969,39.875,3.79,49.844-13.759L507.28,186.564C517.183,168.957,510.998,146.689,493.456,136.72z M156.243,417.443H36.552
                    c-9.178-0.02-16.602-7.444-16.615-16.615V63.551c0.013-9.171,7.437-16.596,16.615-16.615h188.94h22.864h29.108
                    c9.164,0.019,16.602,7.444,16.615,16.615v130.256v114.447v92.575c-0.013,9.171-7.451,16.595-16.615,16.615h-80.678H156.243z
                    M489.931,176.732L323.784,470.279c-4.517,7.976-14.622,10.767-22.592,6.243l-69.184-39.141h45.456
                    c20.184-0.007,36.539-16.362,36.552-36.552v-89.784v-24.812c12.721-5.555,24.526-9.826,30.503-10.793l0.863-0.461l-0.064-0.999
                    c-5.115-13.357-10.365-64.862-6.847-82.606c0.201-1,0.266-1.596-0.195-1.863c-0.467-0.266-0.934,0.065-1.733,0.734
                    c-4.523,3.992-12.889,9.073-22.527,14.103V192.08V63.551c0-1.953-0.202-3.862-0.493-5.738l0.026,0.019l170.066,96.236
                    C491.593,158.585,494.383,168.756,489.931,176.732z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const LikeIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      fill={color}
      height={height}
      width={width}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 208.666 208.666"
      xmlSpace="preserve"
      transform="matrix(-1, 0, 0, -1, 0, 0)"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M54.715,24.957c-0.544,0.357-1.162,0.598-1.806,0.696l-28.871,4.403c-2.228,0.341-3.956,2.257-3.956,4.511v79.825 c0,1.204,33.353,20.624,43.171,30.142c12.427,12.053,21.31,34.681,33.983,54.373c4.405,6.845,10.201,9.759,15.584,9.759 c10.103,0,18.831-10.273,14.493-24.104c-4.018-12.804-8.195-24.237-13.934-34.529c-4.672-8.376,1.399-18.7,10.989-18.7h48.991 c18.852,0,18.321-26.312,8.552-34.01c-1.676-1.32-2.182-3.682-1.175-5.563c3.519-6.572,2.86-20.571-6.054-25.363 c-2.15-1.156-3.165-3.74-2.108-5.941c3.784-7.878,3.233-24.126-8.71-27.307c-2.242-0.598-3.699-2.703-3.405-5.006 c0.909-7.13-0.509-20.86-22.856-26.447C133.112,0.573,128.281,0,123.136,0C104.047,0.001,80.683,7.903,54.715,24.957z" />{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const DislikeIcon = ({
  width = 20,
  height = 20,
  color = "white",
}: Props) => {
  return (
    <svg
      fill={color}
      height={height}
      width={width}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 208.666 208.666"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M54.715,24.957c-0.544,0.357-1.162,0.598-1.806,0.696l-28.871,4.403c-2.228,0.341-3.956,2.257-3.956,4.511v79.825 c0,1.204,33.353,20.624,43.171,30.142c12.427,12.053,21.31,34.681,33.983,54.373c4.405,6.845,10.201,9.759,15.584,9.759 c10.103,0,18.831-10.273,14.493-24.104c-4.018-12.804-8.195-24.237-13.934-34.529c-4.672-8.376,1.399-18.7,10.989-18.7h48.991 c18.852,0,18.321-26.312,8.552-34.01c-1.676-1.32-2.182-3.682-1.175-5.563c3.519-6.572,2.86-20.571-6.054-25.363 c-2.15-1.156-3.165-3.74-2.108-5.941c3.784-7.878,3.233-24.126-8.71-27.307c-2.242-0.598-3.699-2.703-3.405-5.006 c0.909-7.13-0.509-20.86-22.856-26.447C133.112,0.573,128.281,0,123.136,0C104.047,0.001,80.683,7.903,54.715,24.957z" />{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const NotFavoriteIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
}: Props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M17.2 22C19.851 22 22 19.851 22 17.2C22 14.549 19.851 12.4 17.2 12.4C14.549 12.4 12.4 14.549 12.4 17.2C12.4 19.851 14.549 22 17.2 22Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M18.99 17.26H15.41"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M17.2 15.51V19.1"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M22 8.69C22 10.66 21.49 12.4 20.69 13.91C19.81 12.98 18.57 12.4 17.2 12.4C14.55 12.4 12.4 14.55 12.4 17.2C12.4 18.43 12.87 19.55 13.63 20.4C13.26 20.57 12.92 20.71 12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.69C2 5.6 4.49 3.09998 7.56 3.09998C9.37 3.09998 10.99 3.98002 12 5.33002C13.01 3.98002 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.6 22 8.69Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const FavoriteIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
}: Props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M16.44 3.10156C14.63 3.10156 13.01 3.98156 12 5.33156C10.99 3.98156 9.37 3.10156 7.56 3.10156C4.49 3.10156 2 5.60156 2 8.69156C2 9.88156 2.19 10.9816 2.52 12.0016C4.1 17.0016 8.97 19.9916 11.38 20.8116C11.72 20.9316 12.28 20.9316 12.62 20.8116C15.03 19.9916 19.9 17.0016 21.48 12.0016C21.81 10.9816 22 9.88156 22 8.69156C22 5.60156 19.51 3.10156 16.44 3.10156Z"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};

export const ControllerIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      height={height}
      width={width}
      className={className}
    >
      <path
        d="M448 128C554 128 640 214 640 320C640 426 554 512 448 512L192 512C86 512 0 426 0 320C0 214 86 128 192 128L448 128zM192 240C178.7 240 168 250.7 168 264L168 296L136 296C122.7 296 112 306.7 112 320C112 333.3 122.7 344 136 344L168 344L168 376C168 389.3 178.7 400 192 400C205.3 400 216 389.3 216 376L216 344L248 344C261.3 344 272 333.3 272 320C272 306.7 261.3 296 248 296L216 296L216 264C216 250.7 205.3 240 192 240zM432 336C414.3 336 400 350.3 400 368C400 385.7 414.3 400 432 400C449.7 400 464 385.7 464 368C464 350.3 449.7 336 432 336zM496 240C478.3 240 464 254.3 464 272C464 289.7 478.3 304 496 304C513.7 304 528 289.7 528 272C528 254.3 513.7 240 496 240z"
        fill={color}
      />
    </svg>
  );
};

export const CircleXIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      height={height}
      width={width}
      className={className}
    >
      <path
        d="M320 112C434.9 112 528 205.1 528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112zM320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM231 231C221.6 240.4 221.6 255.6 231 264.9L286 319.9L231 374.9C221.6 384.3 221.6 399.5 231 408.8C240.4 418.1 255.6 418.2 264.9 408.8L319.9 353.8L374.9 408.8C384.3 418.2 399.5 418.2 408.8 408.8C418.1 399.4 418.2 384.2 408.8 374.9L353.8 319.9L408.8 264.9C418.2 255.5 418.2 240.3 408.8 231C399.4 221.7 384.2 221.6 374.9 231L319.9 286L264.9 231C255.5 221.6 240.3 221.6 231 231z"
        fill={color}
      />
    </svg>
  );
};

export const NumberedListIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      height={height}
      width={width}
      className={className}
    >
      <path
        d="M64 136C64 122.8 74.7 112 88 112L136 112C149.3 112 160 122.7 160 136L160 240L184 240C197.3 240 208 250.7 208 264C208 277.3 197.3 288 184 288L88 288C74.7 288 64 277.3 64 264C64 250.7 74.7 240 88 240L112 240L112 160L88 160C74.7 160 64 149.3 64 136zM94.4 365.2C105.8 356.6 119.7 352 134 352L138.9 352C172.6 352 200 379.4 200 413.1C200 432.7 190.6 451 174.8 462.5L150.8 480L184 480C197.3 480 208 490.7 208 504C208 517.3 197.3 528 184 528L93.3 528C77.1 528 64 514.9 64 498.7C64 489.3 68.5 480.5 76.1 475L146.6 423.7C150 421.2 152 417.3 152 413.1C152 405.9 146.1 400 138.9 400L134 400C130.1 400 126.3 401.3 123.2 403.6L102.4 419.2C91.8 427.2 76.8 425 68.8 414.4C60.8 403.8 63 388.8 73.6 380.8L94.4 365.2zM288 128L544 128C561.7 128 576 142.3 576 160C576 177.7 561.7 192 544 192L288 192C270.3 192 256 177.7 256 160C256 142.3 270.3 128 288 128zM288 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L288 352C270.3 352 256 337.7 256 320C256 302.3 270.3 288 288 288zM288 448L544 448C561.7 448 576 462.3 576 480C576 497.7 561.7 512 544 512L288 512C270.3 512 256 497.7 256 480C256 462.3 270.3 448 288 448z"
        fill={color}
      />
    </svg>
  );
};

export const StarIcon = ({
  width = 20,
  height = 20,
  color = "white",
  className = "",
  onClick,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      height={height}
      width={width}
      className={className}
      onClick={onClick}
    >
      <path
        d="M341.5 45.1C337.4 37.1 329.1 32 320.1 32C311.1 32 302.8 37.1 298.7 45.1L225.1 189.3L65.2 214.7C56.3 216.1 48.9 222.4 46.1 231C43.3 239.6 45.6 249 51.9 255.4L166.3 369.9L141.1 529.8C139.7 538.7 143.4 547.7 150.7 553C158 558.3 167.6 559.1 175.7 555L320.1 481.6L464.4 555C472.4 559.1 482.1 558.3 489.4 553C496.7 547.7 500.4 538.8 499 529.8L473.7 369.9L588.1 255.4C594.5 249 596.7 239.6 593.9 231C591.1 222.4 583.8 216.1 574.8 214.7L415 189.3L341.5 45.1z"
        fill={color}
      />
    </svg>
  );
};
